import cn from 'classnames';
import { omit } from 'lodash';

import { SquareWithRoundBordersShape } from '../SquareWithRoundBordersShape';

import { getThumbnailImage } from '../../../utils/textHelper';
import { graphColors } from '../consts';
import { graphCurrencyFormatter, graphNumberFormatter } from '../utils';

import styles from './graph-tooltips.module.scss';

export function BestSellersTooltip({ allData, keys, isGmvMetric, currency }) {
  const formatValue = ({ value, formatAsGmv }) =>
    formatAsGmv ? graphCurrencyFormatter(value, currency) : graphNumberFormatter(value);

  return ({ data }) => {
    const onlyBrandsData = omit(data, ['model', 'productImage', 'productName']);
    const otherValues = omit(
      allData[isGmvMetric ? 'units' : 'gmv'].find((datum) => datum.model === data.model),
      ['model', 'productImage', 'productName'],
    );

    const image = getThumbnailImage(data.productImage);

    return (
      <div className={cn(styles.tooltipWrapper, styles.bestSellersTooltip)}>
        <header>
          <img src={image} alt={data.productName} />
          <div className={styles.headerContent}>
            <h4>{data.productName}</h4>
            <p>ID: {data.model}</p>
          </div>
        </header>

        <main>
          <table>
            <tbody>
              {Object.entries(onlyBrandsData).map(([brand, value]) => {
                const colorIndex = keys.indexOf(brand);
                const color = graphColors[colorIndex];

                return (
                  <tr key={brand}>
                    <td className={styles.brandName}>
                      <svg height="14" width="14">
                        <SquareWithRoundBordersShape fill={color} />
                      </svg>
                      {brand}
                    </td>
                    <td>
                      <strong>{formatValue({ value, formatAsGmv: isGmvMetric })}</strong>
                    </td>
                    <td>
                      {otherValues[brand]
                        ? `(${formatValue({ value: otherValues[brand], formatAsGmv: !isGmvMetric })})`
                        : ''}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan={3}>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td>
                  <strong>
                    {formatValue({
                      value: Object.values(onlyBrandsData).reduce((sum, value) => sum + value, 0),
                      formatAsGmv: isGmvMetric,
                    })}
                  </strong>
                </td>
                <td>
                  {Object.values(otherValues).length > 0
                    ? `(${formatValue({
                        value: Object.values(otherValues).reduce((sum, value) => sum + value, 0),
                        formatAsGmv: !isGmvMetric,
                      })})`
                    : ''}
                </td>
              </tr>
            </tbody>
          </table>
        </main>
      </div>
    );
  };
}
